import viewsApi from "./viewsApi";
import {
  actionTypes,
  previewViewUserType,
  viewsIdsResponseType,
} from "./viewsTypes";
import { Dispatch } from "redux/commonTypes";
import authActions from "redux/ducks/auth/authActions"

const Actions = {
  setViewsPreviews: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_VIEWS_PREVIEWS,
    payload: previews,
  }),
  setViewsPreviewsByPage: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_VIEWS_PREVIEWS_BY_PAGE,
    payload: previews,
  }),
  ///////////////////////////////
  setPreviewsNew: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_NEW,
    payload: previews,
  }),
  setPreviewsToday: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_TODAY,
    payload: previews,
  }),
  setPreviewsYesterday: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_YESTERDAY,
    payload: previews,
  }),
  setPreviewsWeek: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_WEEK,
    payload: previews,
  }),
  setPreviewsMonth: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_MONTH,
    payload: previews,
  }),
  setPreviewsEarlier: (previews: Array<previewViewUserType>) => ({
    type: actionTypes.SET_PREVIEWS_EARLIER,
    payload: previews,
  }),
  ////////////////////////////////////
  setLoadingNew: (status: boolean) => ({
    type: actionTypes.SET_LOADING_NEW,
    payload: status,
  }),
  setLoadingToday: (status: boolean) => ({
    type: actionTypes.SET_LOADING_TODAY,
    payload: status,
  }),
  setLoadingYesterday: (status: boolean) => ({
    type: actionTypes.SET_LOADING_YESTERDAY,
    payload: status,
  }),
  setLoadingWeek: (status: boolean) => ({
    type: actionTypes.SET_LOADING_WEEK,
    payload: status,
  }),
  setLoadingMonth: (status: boolean) => ({
    type: actionTypes.SET_LOADING_MONTH,
    payload: status,
  }),
  setLoadingEarlier: (status: boolean) => ({
    type: actionTypes.SET_LOADING_EARLIER,
    payload: status,
  }),
  setLoadingAll: (status: boolean) => ({
    type: actionTypes.SET_LOADING_ALL,
    payload: status,
  }),
  ////////////////////////////////////
  fetchPreviewsNew: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingNew(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsNew(resp.data.visitPreviewUsers||[]))
    })
  },
  fetchPreviewsToday: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingToday(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsToday(resp.data.visitPreviewUsers||[]))
    })
  },
  fetchPreviewsYesterday: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingYesterday(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsYesterday(resp.data.visitPreviewUsers||[]))
    })
  },
  fetchPreviewsWeek: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingWeek(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsWeek(resp.data.visitPreviewUsers||[]))
    })
  },
  fetchPreviewsMonth: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingMonth(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsMonth(resp.data.visitPreviewUsers||[]))
    })
  },
  fetchPreviewsEarlier: (ids: number[]) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingEarlier(true))
    viewsApi.getViewsUsersPreviews(ids).then(resp => {
      dispatch(Actions.setPreviewsEarlier(resp.data.visitPreviewUsers||[]))
    })
  },
  //////////////////////////////////////
  setViewsIds: (views: viewsIdsResponseType) => ({
    type: actionTypes.SET_VIEWS_IDS,
    payload: {
      newViewsCounter: views.new ? views.new.length : 0,
      viewsNewIds: views.new,
      viewsTodayIds: views.today,
      viewsYesterdayIds: views.yesterday,
      viewsLastWeekIds: views.lastWeek,
      viewsLastMonthIds: views.lastMonth,
      viewsEarlierIds: views.earlier,
      allViewsCounter:
        (views?.new?.length||0) +
          (views?.today?.length||0) +
          (views?.yesterday?.length||0) +
          (views?.lastWeek?.length||0) +
          (views?.lastMonth?.length||0) +
          (views?.earlier?.length||0) || 0,
    },
  }),
  addViewNew: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_NEW,
    payload: user,
  }),
  addViewToday: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_TODAY,
    payload: user,
  }),
  addViewYesterday: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_YESTERDAY,
    payload: user,
  }),
  addViewLastWeek: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_LAST_WEEK,
    payload: user,
  }),
  addViewLastMonth: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_LAST_MONTH,
    payload: user,
  }),
  addViewEarlier: (user: previewViewUserType) => ({
    type: actionTypes.ADD_VIEW_EARLIER,
    payload: user,
  }),
  setViewsNewCounter: (counter: number) => ({
    type: actionTypes.SET_VIEWS_NEW_COUNTER,
    payload: counter,
  }),
  pushNewPreview: (preview: Array<previewViewUserType>) => {
    return {
    type: actionTypes.PUSH_NEW_PREVIEW,
    payload: preview,
  }},
  getViews: (timezone: string) => (dispatch: Dispatch) => {
    dispatch(Actions.setLoadingAll(true))
    viewsApi.getViews(timezone).then((resp) => {
      resp.data.visits
      ? dispatch(Actions.setViewsIds(resp.data.visits))
      : dispatch(Actions.setLoadingAll(false));
      if (!resp.data.visits?.new?.length) {
        dispatch(Actions.setPreviewsNew([]))
      }
    })
  },
  readVisits: (ids: Array<number>) => (dispatch: Dispatch) => {
      ids.length && viewsApi.readVisits(ids)
  },
  getNewOneVisit: (id: number) => (dispatch: Dispatch) => {
    viewsApi.getViewsUsersPreviews([id]).then((resp) => {
      dispatch(Actions.pushNewPreview(
        Array.isArray(resp.data.visitPreviewUsers) &&
          resp.data.visitPreviewUsers.map((el: any) => {
            return {
              ...el,
              isNew: true,
            };
          })
      ));
    });
  },
  setPageWasVisited: (status: boolean) => ({
    type: actionTypes.SET_PAGE_WAS_VISITED,
    payload: status
  })
};

export default Actions;
